import { useEffect, useState, useRef } from 'react';
import axios from 'axios';

const API = 'https://ticobaterias.com/api';



export default function Categorias() {
  const [categorias, setCategorias] = useState([]);
  const [modal, setModal] = useState(false);
  const [showPicker, setShowPicker] = useState(false);
  const [editando, setEditando] = useState<any>(null);
  const [form, setForm] = useState({nombre:'', descripcion:'', icono:'🔋', orden:0});
  const [confirmId, setConfirmId] = useState<number|null>(null);
  const [iconoFile, setIconoFile] = useState<File|null>(null);
  const [iconoPreview, setIconoPreview] = useState('');
  const [subiendo, setSubiendo] = useState(false);
  const [toast, setToast] = useState('');
  const [emojisList, setEmojisList] = useState<any[]>([]);
  const iconoRef = useRef<HTMLInputElement>(null);
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const mostrarToast = (msg: string) => { setToast(msg); setTimeout(() => setToast(''), 3000); };
  const cargar = () => axios.get(`${API}/categorias/`).then(r => setCategorias(r.data));
  useEffect(() => {
    cargar();
    axios.get(`${API}/emojis/`).then(r => setEmojisList(r.data));
  }, []);

  const abrir = (c?: any) => {
    if (c) {
      setEditando(c);
      setForm({nombre:c.nombre, descripcion:c.descripcion||'', icono:c.icono||'🔋', orden:c.orden||0});
      setIconoPreview(c.icono_url ? `https://ticobaterias.com${c.icono_url}` : '');
    } else {
      setEditando(null);
      setForm({nombre:'', descripcion:'', icono:'🔋', orden:0});
      setIconoPreview('');
    }
    setIconoFile(null);
    setShowPicker(false);
    setModal(true);
  };

  const seleccionarIcono = (e: any) => {
    const file = e.target.files[0];
    if (file) { setIconoFile(file); setIconoPreview(URL.createObjectURL(file)); }
  };

  const guardar = async (e: any) => {
    e.preventDefault();
    setSubiendo(true);
    try {
      let catId = editando?.id;
      if (editando) {
        await axios.put(`${API}/categorias/${editando.id}`, form, { headers });
      } else {
        const res = await axios.post(`${API}/categorias/`, form, { headers });
        catId = res.data.id;
      }
      if (iconoFile && catId) {
        const fd = new FormData();
        fd.append('file', iconoFile);
        await axios.post(`${API}/categorias/${catId}/icono`, fd, { headers: {...headers, 'Content-Type':'multipart/form-data'} });
      }
      setModal(false);
      cargar();
      mostrarToast(editando ? '✅ Categoría actualizada' : '✅ Categoría creada');
    } catch { mostrarToast('❌ Error al guardar'); }
    setSubiendo(false);
  };

  const eliminar = async (id: number) => {
    await axios.delete(`${API}/categorias/${id}`, { headers });
    setConfirmId(null);
    cargar();
    mostrarToast('🗑️ Categoría eliminada');
  };

  return (
    <div>
      {toast && (
        <div className="fixed top-6 right-6 z-50 bg-white border border-gray-200 shadow-xl rounded-xl px-5 py-3 text-sm font-semibold text-gray-700">{toast}</div>
      )}

      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="font-bold text-2xl text-azul">Categorías</h1>
          <p className="text-gray-500 text-sm">{categorias.length} categorías registradas</p>
        </div>
        <button onClick={() => abrir()} className="bg-azul text-white px-5 py-2.5 rounded-xl font-bold text-sm hover:bg-azul-dark transition-colors">
          + Agregar categoría
        </button>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {(categorias as any[]).map((c: any) => (
          <div key={c.id} className="bg-white rounded-2xl border border-gray-100 p-5 flex items-center gap-4 hover:border-azul transition-colors">
            <div className="w-14 h-14 bg-azul/10 rounded-xl flex items-center justify-center text-3xl flex-shrink-0 overflow-hidden">
              {c.icono_url
                ? <img src={`https://ticobaterias.com${c.icono_url}`} alt={c.nombre} className="w-full h-full object-cover"/>
                : c.icono
              }
            </div>
            <div className="flex-1">
              <div className="font-bold text-azul">{c.nombre}</div>
              <div className="text-gray-400 text-sm mt-0.5">{c.descripcion}</div>
            </div>
            <div className="flex gap-2">
              <button onClick={() => abrir(c)} className="text-azul hover:bg-azul/10 px-3 py-1.5 rounded-lg text-xs font-bold transition-colors">Editar</button>
              <button onClick={() => setConfirmId(c.id)} className="text-rojo hover:bg-rojo/10 px-3 py-1.5 rounded-lg text-xs font-bold transition-colors">Eliminar</button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal confirmar */}
      {confirmId !== null && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6">
            <div className="text-4xl text-center mb-3">🗑️</div>
            <h3 className="text-lg font-bold text-gray-800 text-center mb-2">¿Eliminar categoría?</h3>
            <p className="text-sm text-gray-500 text-center mb-6">Esta acción no se puede deshacer.</p>
            <div className="flex gap-3">
              <button onClick={() => setConfirmId(null)} className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button onClick={() => eliminar(confirmId)} className="flex-1 px-4 py-2.5 rounded-xl bg-rojo hover:bg-rojo-dark text-white text-sm font-semibold">Sí, eliminar</button>
            </div>
          </div>
        </div>
      )}

      {modal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-100">
              <h2 className="font-bold text-lg text-azul">{editando ? 'Editar categoría' : 'Nueva categoría'}</h2>
            </div>
            <form onSubmit={guardar} className="p-6 space-y-4">

              {/* Ícono personalizado */}
              <div>
                <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">ÍCONO PERSONALIZADO (opcional)</label>
                <div onClick={() => iconoRef.current?.click()}
                  className="border-2 border-dashed border-gray-200 rounded-xl p-4 text-center cursor-pointer hover:border-azul transition-colors">
                  {iconoPreview ? (
                    <img src={iconoPreview} alt="" className="h-16 mx-auto object-contain rounded-lg"/>
                  ) : (
                    <div className="py-2">
                      <div className="text-2xl mb-1">🖼️</div>
                      <p className="text-gray-400 text-xs">Clic para subir imagen de ícono</p>
                      <p className="text-gray-300 text-xs mt-0.5">PNG, SVG, WEBP recomendado</p>
                    </div>
                  )}
                </div>
                <input ref={iconoRef} type="file" accept="image/*" onChange={seleccionarIcono} className="hidden"/>
              </div>

              {/* Ícono emoji */}
              <div className="grid grid-cols-4 gap-3">
                <div>
                  <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">ÍCONO EMOJI</label>
                  <button type="button" onClick={() => setShowPicker(!showPicker)}
                    className="w-full border-2 border-gray-200 rounded-lg py-2 text-3xl text-center hover:border-azul transition-colors">
                    {form.icono}
                  </button>
                </div>
                <div className="col-span-3">
                  <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">NOMBRE</label>
                  <input required value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})}
                    className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul"/>
                </div>
              </div>

              {showPicker && (
                <div className="border border-gray-200 rounded-xl p-3 bg-gray-50">
                  <div className="text-xs font-bold text-gray-500 tracking-wider mb-2">SELECCIONAR ÍCONO</div>
                  <div className="grid grid-cols-8 gap-1">
                    {emojisList.map((item: any) => (
                      <button key={item.id} type="button" onClick={() => {
                        if (item.imagen_url) {
                          setIconoPreview(`https://ticobaterias.com${item.imagen_url}`);
                          setForm({...form, icono: item.nombre||''});
                        } else {
                          setIconoPreview('');
                          setForm({...form, icono: item.emoji||''});
                        }
                        setShowPicker(false);
                      }}
                        className="p-1.5 rounded-lg hover:bg-azul/10 transition-colors flex items-center justify-center border border-transparent hover:border-azul">
                        {item.imagen_url
                          ? <img src={`https://ticobaterias.com${item.imagen_url}`} alt={item.nombre||''} className="h-8 w-8 object-contain"/>
                          : <span className="text-2xl">{item.emoji}</span>
                        }
                      </button>
                    ))}
                  </div>
                </div>
              )}

              <div>
                <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">DESCRIPCIÓN</label>
                <input value={form.descripcion} onChange={e => setForm({...form, descripcion: e.target.value})}
                  className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul"/>
              </div>
              <div>
                <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">ORDEN</label>
                <input type="number" value={form.orden} onChange={e => setForm({...form, orden: parseInt(e.target.value)})}
                  className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul"/>
              </div>
              <div className="flex gap-3 pt-2">
                <button type="submit" disabled={subiendo} className="flex-1 bg-azul text-white py-2.5 rounded-xl font-bold text-sm hover:bg-azul-dark transition-colors disabled:opacity-50">
                  {subiendo ? 'Guardando...' : editando ? 'Guardar cambios' : 'Crear categoría'}
                </button>
                <button type="button" onClick={() => setModal(false)} className="px-6 border border-gray-200 rounded-xl text-gray-500 text-sm">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
